import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const STORAGE_KEY = 'crv.selectedCompanyId';

interface TenancyState {
  selectedCompanyId: string | null;
  setSelectedCompanyId: (companyId: string | null) => void;
  clearSelectedCompany: () => void;
}

type LocalStorageLike = {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
};

const storage =
  'localStorage' in globalThis
    ? createJSONStorage(
        () => (globalThis as unknown as { localStorage: LocalStorageLike }).localStorage,
      )
    : undefined;

export const useTenancyStore = create<TenancyState>()(
  persist(
    (set) => ({
      selectedCompanyId: null,
      setSelectedCompanyId: (companyId: string | null): void => {
        set({ selectedCompanyId: companyId?.trim() || null });
      },
      clearSelectedCompany: (): void => {
        set({ selectedCompanyId: null });
      },
    }),
    {
      name: STORAGE_KEY,
      storage,
      partialize: (state) => ({ selectedCompanyId: state.selectedCompanyId }),
    },
  ),
);
